import { expensesGroupedByDateAtom } from "@/store/global";
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
} from "@/components/ui/dropdown-menu";

import { useAtom } from "jotai";
import { useNavigate } from "@tanstack/react-router";
import { PencilIcon, Trash2Icon } from "lucide-react";
import { useMounted } from "@mantine/hooks";

export const ListExpense = () => {
  const [expensesGroupedByDate] = useAtom(expensesGroupedByDateAtom);
  const isMounted = useMounted();
  const navigate = useNavigate();

  return (
    <section className="transaction-list flex-1 space-y-5 pb-24">
      {isMounted &&
        Object.entries(expensesGroupedByDate).map(([date, expenses]) => (
          <div key={date}>
            <div className="mb-3 ml-12 flex items-center justify-between border-b border-neutral-200 pb-2 text-sm font-bold text-neutral-500">
              <h2>{date}</h2>
              <span>
                Rp
                {expenses.reduce((acc, expense) => acc + expense.amount, 0).toLocaleString("id-ID")}
              </span>
            </div>

            <ul className="space-y-2.5">
              {expenses.map((expense, i) => (
                <DropdownMenu key={`dropdown-expense-${expense.date}-${i}`}>
                  <DropdownMenuTrigger asChild>
                    <li key={`expense-${expense.date}-${i}`} className="flex cursor-pointer justify-between">
                      <div className="flex items-center space-x-2.5">
                        <div
                          className="flex min-h-9 min-w-9 items-center justify-center rounded-lg"
                          style={{
                            backgroundColor: `${expense.color}dd`,
                          }}
                        >
                          {expense.emoji}
                        </div>
                        <div className="flex flex-col">
                          <span className="text-sm font-semibold text-neutral-900">
                            {expense.category || "Belum ada kategori"}
                          </span>
                          <div className="flex items-center space-x-1 text-xs">
                            <span className="font-medium text-neutral-500">{expense.notes.trim() || "Belum ada catatan"}</span>
                          </div>
                        </div>
                      </div>
                      <strong
                        className="text-sm font-semibold"
                        style={{
                          viewTransitionName: expense.amount.toLocaleString("id-ID"),
                        }}
                      >
                        Rp{expense.amount.toLocaleString("id-ID")}
                      </strong>
                    </li>
                  </DropdownMenuTrigger>
                  <DropdownMenuContent>
                    <DropdownMenuLabel className="text-sm font-medium text-neutral-500">
                      {expense.category} - Rp{expense.amount.toLocaleString("id-ID")}
                    </DropdownMenuLabel>
                    <DropdownMenuSeparator />
                    <DropdownMenuItem
                      data-attr="list-expense-update-button"
                      className="space-x-2 font-medium"
                      onClick={() => {
                        navigate({ to: `/pengeluaran`, search: { action: "update", id: expense.id } });
                      }}
                    >
                      <PencilIcon size={16} className="text-neutral-500" />
                      <span>Ubah</span>
                    </DropdownMenuItem>
                    <DropdownMenuItem
                      data-attr="list-expense-delete-button"
                      className="space-x-2 font-medium text-red-500 hover:!bg-red-50 hover:!text-red-600"
                      onClick={() => {
                        navigate({ to: `/hapus`, search: { id: expense.id } });
                      }}
                    >
                      <Trash2Icon size={16} />
                      <span>Hapus</span>
                    </DropdownMenuItem>
                  </DropdownMenuContent>
                </DropdownMenu>
              ))}
            </ul>
          </div>
        ))}
    </section>
  );
};
